var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.802,
    height: 12.882,
    viewBox: "0 0 13.802 12.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-camera-slash-fill",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13748",
    "data-name": "Path 13748",
    d: "M20.762,28.112a.46.46,0,1,1-.681.619l-2.435-2.679a.921.921,0,0,1-.905.759H10.3a2.3,2.3,0,0,1-2.3-2.3V18.99a.921.921,0,0,1,.92-.92H10.39l-1.183-1.3a.46.46,0,1,1,.681-.619Zm.811-8.83a.46.46,0,0,0-.459,0l-2.3,1.315a.46.46,0,0,0-.232.4v2.892a.46.46,0,0,0,.232.4l2.3,1.315a.46.46,0,0,0,.688-.4V19.68a.46.46,0,0,0-.229-.4Zm-4.712,3.17a.46.46,0,0,0,.8-.31V20.37a2.3,2.3,0,0,0-2.3-2.3H13.917a.46.46,0,0,0-.34.77Z",
    transform: "translate(-8 -15.999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video-off.6b2d44a91fad8d182387aa9c721a6b4a.svg";
export { ForwardRef as ReactComponent };